import type { FC, PropsWithChildren } from 'react';
import { Modal, ModalForm, InputsSection, ModalButtons } from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ToggleModalSkeleton from '../../Skeletons/ToggleModalSkeleton';
import { DeleteModalState } from './DeleteModal';
import {Button} from '../../components/Modal';

type ModalProps = PropsWithChildren<{
  loading: boolean;
  toggleModal: DeleteModalState;
  onCloseModal?: () => void;
  handleToggle?: (event: React.FormEvent<HTMLFormElement>) => void;
}>;
export interface IbillingProvider{
    _id:string,
    name:string
}
const ViewProviderModal: FC<ModalProps> = props => {
const billingProvider = props.toggleModal.data?.billingProvider as IbillingProvider[] || [];



  return (
    <Modal show={props.toggleModal.status} style={{ fontFamily: "Roboto",borderRadius:"1rem"}}>
      <ModalHeading heading="Billing Provider" />

      {props.loading ? (
        <ToggleModalSkeleton />
      ) : (
        props.toggleModal.data && (
          <ModalForm
            style={{
              marginBottom: "1rem",
              fontSize: "1.4rem",
              fontFamily: "Roboto",
            }}
            onSubmit={props.handleToggle}
          >
            {/* Category List */}
            <div style={{ marginTop: "1rem" }}>
              {billingProvider.length > 0 ? (
                <ol style={{ marginTop: "0.5rem", paddingLeft: "1.5rem" }}>
                  {billingProvider.map((cat) => (
                    <li key={cat?._id} style={{ fontSize: "1.4rem" }}>
                       {cat?.name}
                    </li>
                  ))}
                </ol>
              ) : (
                <p style={{ fontStyle: "italic", color: "gray" }}>
                  No Billing Provider found.
                </p>
              )}
            </div>

            {/* Right-aligned Close button */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "2rem",
              }}
            >
              <Button
                label="Close"
                span={false}
                submitButtonStyle={{
                  color: "#4B5563",
                  background: "#FFFFFF",
                  border: "1px solid #E5E7EB",
                  fontSize: "1.4rem",
                  fontWeight: "400",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={props.onCloseModal}
              />
            </div>
          </ModalForm>
        )
      )}
    </Modal>
  );
};

export default ViewProviderModal;